import { useField } from "formik";
import { EventTypeOptionResource } from "../../types/eventType";

export const useEventTypeField = () => {
	const [{ value }] = useField<EventTypeOptionResource | null>("eventType");

	return value;
};
